<template>
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24ZM23.9654 17.6213C25.9155 17.6213 27.2309 18.4649 27.9809 19.1698L30.9118 16.304C29.1117 14.6285 26.7694 13.6 23.9654 13.6C19.9037 13.6 16.3959 15.9342 14.6881 19.3316L14.6882 19.3316C13.9843 20.7413 13.5804 22.3245 13.5804 24C13.5804 25.6756 13.9843 27.2587 14.6882 28.6684L18.0418 26.069L14.6996 28.6685C16.4074 32.0658 19.9037 34.4 23.9653 34.4C26.7693 34.4 29.1232 33.4756 30.8425 31.8809L27.5655 29.3387C26.6885 29.9511 25.5116 30.3787 23.9653 30.3787C21.2191 30.3787 18.8883 28.5645 18.0575 26.0569L18.0575 26.0569C17.8383 25.4098 17.7114 24.7164 17.7114 24C17.7114 23.2836 17.8383 22.5902 18.046 21.9431C18.8883 19.4356 21.2192 17.6213 23.9654 17.6213ZM18.0575 26.0569C18.0574 26.0569 18.0574 26.0569 18.0574 26.0569L18.0418 26.069L18.0575 26.0569ZM18.046 21.9431L14.6882 19.3316L14.6882 19.3316L18.046 21.9431L18.046 21.9431ZM33.7158 22.1049C33.8658 22.752 33.935 23.376 33.935 24.2311C33.935 27.3973 32.8042 30.0667 30.8426 31.8809L27.5656 29.3387C28.9502 28.368 29.5733 26.9236 29.6887 25.9645H23.9654V22.1049H33.7158Z"
      fill="#FF0000"
    />
  </svg>
</template>

<script>
  export default {
    name: 'GoogleIcon'
  }
</script>


// WEBPACK FOOTER //
// google.vue?311447e3